import labels from './i18n/localToggle.js';

/**
 * localToggle - Append a button into each items to close it
 *
 * @param  {object} widget The accordion instance to add local toggle
 * @return {object}        The destroy method to remove everything create by the module
 */
function localToggle(widget) {
  const buttons = [];

  /**
   * create - Handle the button creation
   *
   * @return {undefined}
   */
  function create() {
    widget.items.each(function (index, collections) {
      buttons[index] = createButton(index, labels.close);
      $(this).append(buttons[index][0]);
      $(this).attr('id', `${widget.guid}-local-toggle-${index}`);
      $('summary', this).attr(
        'id',
        `${widget.guid}-summary-local-toggle-${index}`
      );
    });
  }

  /**
   * createButton - Create the markup of the button
   *
   * @param  {integer} index The index of the button
   * @param  {string} text The button text content
   * @return {object} Skizz object of the button
   */
  function createButton(index, text) {
    return $('<button></button>')
      .addClass(`${widget.id}-local-toggle`)
      .attr('data-index', index)
      .attr('aria-controls', `${widget.guid}-local-toggle-${index}`)
      .attr('aria-describedby', `${widget.guid}-summary-local-toggle-${index}`)
      .text(text)
      .on('click', eventHandler);
  }

  /**
   * eventHandler - Handle button's logic
   *
   * @param  {type} event The event object
   * @return {undefined}
   */
  function eventHandler(event) {
    event.preventDefault();
    const index = $(event.target).attr('data-index');
    widget.close(index);
  }

  /**
   * destroy - Clears event listeners and remove elements
   * created during initialization
   *
   * @return {type}  description
   */
  function destroy() {
    buttons.forEach((button) => {
      button.off('click', eventHandler);
      button.detach();
    });
  }

  create();

  return {
    destroy
  };
}

localToggle.id = 'localToggle';

export default localToggle;
